import { gettext } from "../utils/legacy";
import cropr from "../../shared/utils/cropr";
import React from "react";

interface DeleteButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  onDelete: () => void;
  confirmMsg?: string;
}

function wrapConfirm(callback: () => void, confirmMsg?: string) {
  return confirmMsg ? () => cropr.confirm(confirmMsg) && callback() : callback;
}

const DeleteButton = ({ children, onDelete, confirmMsg, ...props }: DeleteButtonProps) => (
  <button
    type="button"
    className="btn text-danger"
    {...props}
    onClick={wrapConfirm(onDelete, confirmMsg)}
  >
    {children || gettext("Delete")}
  </button>
);
export default DeleteButton;
